// Cardurile de licitatie din colectii / cautare (23 oct 2026, ca la Troostwijk):
// timer, "n oferte · X RON" sau "Preț de pornire", starea rezervei. O singura
// cerere pt toate cardurile din pagina; timer-ul merge la secunda.
(function () {
  const API = 'https://2hand-sync.vercel.app/api';
  const RESERVE = { none: ['Fără preț de rezervă', '#16a34a'], not_met: ['Preț de rezervă neatins', '#111'], met: ['✓ Preț de rezervă atins', '#16a34a'] };
  const DAYS = ['duminică', 'luni', 'marți', 'miercuri', 'joi', 'vineri', 'sâmbătă'];
  const ENDED = { ended_no_bids: 'Încheiată', ended_reserve_not_met: 'Încheiată', ended_pending_checkout: 'Încheiată', ended_completed: 'Vândută', ended_buy_now: 'Vândută', ended_unpaid: 'Încheiată', cancelled: 'Anulată', finalizing: 'Se încheie...' };
  const ron = c => (c / 100).toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' RON';
  const t = s => Date.parse(String(s).replace(' ', 'T') + 'Z');
  const pad = n => (n < 10 ? '0' : '') + n;
  function when(s) {
    const d = new Date(t(s));
    const hm = pad(d.getHours()) + ':' + pad(d.getMinutes());
    if (d - Date.now() < 7 * 86400000) return DAYS[d.getDay()].replace(/^./, c => c.toUpperCase()) + ' la ' + hm;
    return d.toLocaleDateString('ro-RO', { day: 'numeric', month: 'short' }) + ' la ' + hm;
  }
  // Ca la Troostwijk: sub 24h numaratoare HH:MM:SS, altfel ziua + ora.
  function timerText(a) {
    if (a.status === 'scheduled') return 'Începe ' + when(a.starts_at);
    if (a.status !== 'live') return ENDED[a.status] || 'Încheiată';
    const ms = t(a.ends_at) - Date.now();
    if (ms <= 0) return 'Se încheie...';
    if (ms < 86400000) { const s = Math.floor(ms / 1000); return pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s % 3600 / 60)) + ':' + pad(s % 60); }
    return when(a.ends_at);
  }
  function render(el, a) {
    const live = a.status === 'live' || a.status === 'scheduled';
    const r = RESERVE[a.reserve_status];
    el.innerHTML =
      `<span class="auction-card-timer${live && t(a.ends_at) - Date.now() < 3600000 ? ' urgent' : ''}" data-ends="${a.ends_at}" data-starts="${a.starts_at}" data-status="${a.status}">⏱ ${timerText(a)}</span>` +
      `<span class="auction-card-line">${a.bid_count ? a.bid_count + (a.bid_count === 1 ? ' ofertă' : ' oferte') : 'Preț de pornire'}</span>` +
      `<span class="auction-card-price">${ron(a.bid_count ? a.current_price_cents : a.starting_price_cents)}</span>` +
      (live && r ? `<span class="auction-card-reserve" style="color:${r[1]};border-color:${r[1]}">${r[0]}</span>` : '');
    el.dataset.loaded = '1';
  }
  async function load() {
    const els = [...document.querySelectorAll('[data-auction-card]:not([data-loaded])')];
    if (!els.length) return;
    els.forEach(e => { e.dataset.loaded = 'pending'; });
    const ids = [...new Set(els.map(e => e.dataset.auctionCard))].join(',');
    try {
      const d = await (await fetch(`${API}/auction-status?card_ids=${ids}`)).json();
      const by = {};
      for (const a of d.auctions || []) by[a.product_id] = a;
      for (const e of els) { if (by[e.dataset.auctionCard]) render(e, by[e.dataset.auctionCard]); }
    } catch (err) {
      // Faza 4 (23 oct 2026): inainte, la eroare se reincerca LA FIECARE SECUNDA
      // (timer-ul modifica pagina -> MutationObserver -> load()), adica un
      // vizitator bombarda API-ul exact cand avea probleme. Acum: o reincercare
      // dupa 30s, iar cardurile "failed" nu mai declanseaza observer-ul.
      els.forEach(e => { e.dataset.loaded = 'failed'; });
      setTimeout(() => { els.forEach(e => { if (e.dataset.loaded === 'failed') delete e.dataset.loaded; }); load(); }, 30000);
    }
  }
  setInterval(() => {
    document.querySelectorAll('.auction-card-timer[data-ends]').forEach(el => {
      const a = { ends_at: el.dataset.ends, starts_at: el.dataset.starts, status: el.dataset.status };
      el.textContent = '⏱ ' + timerText(a);
      el.classList.toggle('urgent', a.status === 'live' && t(a.ends_at) - Date.now() < 3600000);
    });
  }, 1000);
  function start() {
    load();
    let tm = null;
    new MutationObserver(() => {
      if (tm) return;
      tm = setTimeout(() => { tm = null; if (document.querySelector('[data-auction-card]:not([data-loaded])')) load(); }, 300);
    }).observe(document.body, { childList: true, subtree: true });
  }
  window.AuctionCardUtils = { timerText, ron, RESERVE };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
